import { Injectable } from '@angular/core';
import { IPlanningGenerationSelection } from '../models/planning-generation-selection.model';
import { IPlanningGenerationSummary } from '../models/planning-generation-summary.model';
import { CostAccountingRequestService } from '../services/cost-accounting-request.request.service';
import { Observable } from 'rxjs';
import { Moment } from 'moment';
import { Params } from '@angular/router';
import { IPlannedSaleVolume } from '../models/planned-sale-volume.model';
import { IAddPlannedSaleVolume } from '../models/add-planned-sale-volume.model';
import { IUpdatePlannedSaleVolume } from '../models/update-planned-sale-volume.model';

const BASE_URL: string = 'planned-sale-volume';
const DATEFORMAT: string = 'YYYY-MM-DD';


@Injectable({
    providedIn: 'root',
})
export class PlannedSaleVolumeResource {
    constructor(private myCostAccountingRequestService: CostAccountingRequestService) {
    }

    public getPlannedSaleVolumes(costUnitId?: number, startDate?: Moment, endDate?: Moment): Observable<IPlannedSaleVolume[]> {
        const params: Params = {};
        if (costUnitId) {
            params[ 'costUnitId' ] = costUnitId;
        }
        if (startDate && endDate) {
            params[ 'startDate' ] = startDate.format(DATEFORMAT);
            params[ 'endDate' ] = endDate.format(DATEFORMAT);
        }
        return this.myCostAccountingRequestService.get<IPlannedSaleVolume[]>(BASE_URL, { params });
    }

    public addPlannedSaleVolume(values: IAddPlannedSaleVolume): Observable<IPlannedSaleVolume> {
        return this.myCostAccountingRequestService.post(BASE_URL, values);
    }

    public updatePlannedSaleVolume(id: number, values: IUpdatePlannedSaleVolume): Observable<IPlannedSaleVolume> {
        return this.myCostAccountingRequestService.patch(`${BASE_URL}/${id}`, values);
    }

    public deletePlannedSaleVolume(id: number): Observable<void> {
        return this.myCostAccountingRequestService.delete(`${BASE_URL}/${id}`);
    }

    public generateVolumes(generationSelection: IPlanningGenerationSelection): Observable<IPlanningGenerationSummary> {
        return this.myCostAccountingRequestService.post(`${BASE_URL}/generate`, generationSelection);
    }
}
